<template>
  <div class="container">
    <topBanner class="top-banner" />

    <div class="gallery">
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653116793.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653123050.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653121636.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653113105.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653113778.jpg>
     <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653117127.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653117127.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653116663.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://images.unsplash.com/photo-1550664865-e35e69d95f48?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653113556.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://images.unsplash.com/photo-1547898812-9e25c5a693e0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653117127.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653117127.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653113105.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653116526.jpg">
      </div>    <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653121414.jpg">
      </div>    <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653116526.jpg">
      </div>    <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653116663.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653116526.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653123050.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653113105.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653117127.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653116526.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653116793.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653117127.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653123050.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://images.unsplash.com/photo-1474524955719-b9f87c50ce47?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://images.unsplash.com/photo-1526749837599-b4eba9fd855e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60">
  
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653120714.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653117127.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653120714.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653117127.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653120714.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653117127.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653113556.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653113938.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653119336.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653121414.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653121414.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653121414.jpg">
      </div>
      <div class="item">
        <div class="overlay">
          <p>View</p>
        </div>
        <img src="https://b2bservis.buldans.com.tr/Uploads/8681653121414.jpg">
      </div>
    </div>
  
  </div>
  
  

</template>

<script>
import topBanner from "../components/topBanner";

export default {
  data() {
    return {
      selectedImageURL: null,
      imageList: [
        { url: "https://b2bservis.buldans.com.tr/Uploads/8681653116793.jpg" },
        // Add other image URLs here
      ],
    };
  },
  components: {
    topBanner,
  },
  methods: {
    openImageViewer(imageURL) {
      this.selectedImageURL = imageURL;
    },
    closeImageViewer() {
      this.selectedImageURL = null;
    },
  },
};
</script>
<style scoped lang="scss">
.top-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000; /* Adjust the z-index as needed to ensure it appears above other elements */
}
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-template-rows: repeat(10, 100px);
  grid-gap: 5px;
  grid-auto-flow: dense;
  .item {
    position: relative;
    overflow: hidden;
    grid-column: span 1;
    grid-row: span 1;
    &:hover .overlay {
      transform: translateY(0);
    }
    &:nth-child(even) {
      grid-column: span 2;
      grid-row: span 2;
    }
    &:nth-child(3n) {
      grid-row: 3, span 3;
      grid-column: span 2;
    }
    img {
      width: 150%;
      height: 170%;
      object-fit: cover;
      object-position: center;
    }
    .overlay {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: linear-gradient(45deg, rgba(97, 73, 200, 0.8), rgba(102, 122, 255, 0.8));
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translateY(100%);
      transition: 0.3s cubic-bezier(.6,0,.2,1);
      p {
        margin: 0;
        color: #fff;
        border: 2px solid #fff;
        padding: 6px 14px;
        cursor: pointer;
        &:hover {
          background: #fff;
          color: rgb(97, 73, 200);
        }
      }
    }
  }
}

.image-viewer {
  position: fixed;
  background: rgba(35, 31, 32, 0.8);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
  
  img {
    max-width: 1000px;
    box-shadow: 0 10px 40px -10px rgba(0,0,0,0.6);
  }
}
</style>
